import React, { Component } from 'react';
import { Header, List, Table } from 'semantic-ui-react';

export default class GroupProjectPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Group research project" />
        <p>
          You will complete a semester-long research project in groups of 2 - 4.
          At a high level, successful projects will raise an important research question, and
          plan and execute a methodology for answering that question. Often, this methodology will
          include building and evaluating a prototype system, but hacking is not strictly necessary.
          There are many creative ways to mock up novel systems. All projects require a evaluation —
          obviously a much more thorough study will be expected of projects that do not involve
          system building.
        </p>

        <p>
          While there is no specific formula for conducting good research, there are a number of
          loosely ordered high-level steps. Your group project will subsist of a number of assignments
          that follow these high-level steps (linked later in this page).
        </p>

        <p>
          For information on how the project will be evaluated, see the individual rubrics under each assignment.
        </p>

        <p>
          Groups that do excellent projects will be encouraged to submit their research to an appropriate publication venue.
          The last time this course was offered, 2/4 projects were not only published at reputable venues, they won awards.
          You can read those final papers here:
        </p>

        <List bulleted>
          <List.Item>
            <a href="https://sauvikdas.com/papers/25/serve" target="_blank">
              Fanelle, V., Karimi, S., Shah, A., Subramanian, B., & Das, S. (2020).
              Blind and Human: Exploring More Usable Audio CAPTCHA Designs.
              In Sixteenth Symposium on Usable Privacy and Security (SOUPS 2020) (pp. 111-125).
            </a> <strong>Distinguished Paper Award</strong>
          </List.Item>
          <List.Item>
            <a href="https://sauvikdas.com/papers/31/serve" target="_blank">
              Ernala, S. K., Yang, S. S., Wu, Y., Chen, R., Wells, K., & Das, S. (2021).
              Exploring the Utility Versus Intrusiveness of Dynamic Audience Selection on Facebook.
              Proceedings of the ACM on Human-Computer Interaction, 5(CSCW2), 1-30.
            </a> <strong>Best Paper Honorable Mention Award</strong>
          </List.Item>
        </List>

         <Table basic='very' collapsing>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Assignment</Table.HeaderCell>
              <Table.HeaderCell>Due date</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell><a href="/individual-ideation">Individual Ideation (2%)</a></Table.Cell>
              <Table.Cell>1/18/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/group-ideation">Group Ideation (4%)</a></Table.Cell>
              <Table.Cell>1/27/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/proposals">Project Proposal (4%)</a></Table.Cell>
              <Table.Cell>2/3/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/proposals#revision">Project Proposal Revision (6%)</a></Table.Cell>
              <Table.Cell>2/15/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/progress-reports">Progress Report 1 (6%)</a></Table.Cell>
              <Table.Cell>2/24/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/progress-reports#2">Progress Report 2 (8%)</a></Table.Cell>
              <Table.Cell>3/17/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/final-presentation">Final Presentation (8%)</a></Table.Cell>
              <Table.Cell>4/19/22</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/final-paper">Final Project+Paper (12%)</a></Table.Cell>
              <Table.Cell>4/26/22</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/group-project-page.js